// @mui icons
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";
import YouTubeIcon from "@mui/icons-material/YouTube";
import RedditIcon from "@mui/icons-material/Reddit";

// Material Kit 2 React components
import MKTypography from "components/MKTypography";

// Images
import logoCT from "assets/images/Logo/LKGameArt/Logo.png";

// Pages
import LKGameArtLegalPage from "layouts/pages/legal/lkgameart";

const date = new Date().getFullYear();

export default {
  brand: {
    name: "LKGameArt",
    image: logoCT,
    route: "/",
  },
  socials: [
    {
      icon: <TwitterIcon />,
      link: "https://x.com/LKGameArt",
    },
    {
      icon: <InstagramIcon />,
      link: "https://www.instagram.com/lk_game_art/",
    },
    {
      icon: <RedditIcon />,
      link: "https://www.reddit.com/user/LK_Game_Art/",
    },
    {
      icon: <YouTubeIcon />,
      link: "https://www.youtube.com/@xmaster2010x",
    },
  ],
  menus: [
    {
      name: "legal",
      items: [
        {
          name: "privacy policy",
          route: "/privacypolicy",
          component: <LKGameArtLegalPage />,
        },
      ],
    },
  ],
  copyright: (
    <MKTypography variant="button" fontWeight="regular">
      All rights reserved. Copyright &copy; {date} by LKGameArt.
    </MKTypography>
  ),
};
